import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PaymentActionCompleteComponent } from './payment-action-complete/payment-action-complete.component';
import { PaymentActionComponent } from './payment-action/payment-action.component';
import { PaymentErrorComponent } from './payment-error/payment-error.component';
import { PaymentLayoutComponent } from './payment-layout/payment-layout.component';
import { PaymentRejectionReasonsComponent } from './payment-rejection-reasons/payment-rejection-reasons.component';
import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentTitleSummaryComponent } from './payment-title-summary/payment-title-summary.component';
import { CommissionResolver, CommissionService, CommissionStore, PaymentGuard } from './service';

@NgModule({
  imports: [
    SharedModule,
    PaymentRoutingModule,
  ],
  declarations: [
    PaymentActionCompleteComponent,
    PaymentActionComponent,
    PaymentErrorComponent,
    PaymentLayoutComponent,
    PaymentRejectionReasonsComponent,
    PaymentTitleSummaryComponent,
  ],
  providers: [
    CommissionResolver,
    CommissionService,
    CommissionStore,
    PaymentGuard,
  ]
})
export class PaymentModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment.module.ts